<template>
  <div>
    <v-row class="mt-15"></v-row>
    <v-footer fixed padless inset class="footer-wrapper mb-0 py-5"       hide-on-scroll
>
    <v-row justify="start" align="center">
        <v-col class="text-center px-8 py-1 footer-section ">
            {{ displayName }} &copy; {{ year }}
            <span class="mx-2">|</span>
            <span dir="ltr">COPYRIGHT keyanAlhadaria</span>
        </v-col>
    </v-row>
  </v-footer>
  </div>

</template>

<script>
export default {
  computed: {
    // The organisation's name (or the generic portal name); the vendor credit follows it.
    displayName() {
      return this.$store.getters["organization/displayName"];
    },
    year() {
      return new Date().getFullYear();
    },
  },
};
</script>